export default {"src":"/_next/static/media/duiken.56bd8665.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};